import { addSearchParamsToUrl } from 'utils/clickme';
import { CLICKME_LINK_PROMO } from 'utils/constants/app';

const LandingPageStub = () => {
    window.location.href = addSearchParamsToUrl(CLICKME_LINK_PROMO);
    return null;
};
export default LandingPageStub;
